export enum DetailsPageViewTypeEnum {
  paymentLink = 'paymentLink',
  transactions = 'transactions',
}
